export const SECTION_HEADING_ID = 'page-heading-id';
